import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import ViewTable from "./ViewTable";
import { useDispatch, useSelector } from "react-redux";
import LogsTable from "./LogsTable";
import FullPageLoader from "components/common/FullPageLoader";
import { fetchInterpreterAppointmentView } from "slices/interpreter/appointmentSlice";
import { fetchInterpreterAppointmentLogs } from "slices/interpreter/appointmentSlice";
import { setActionAssign } from "slices/actionButtonSlice";
import moment from "moment-timezone";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import CancelModal from "components/appointment/CancelModal";
import { closeAppointmentPopup } from "slices/appointmentSlice";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Video } from "lucide-react";
import { setInterpreterIframeUrl } from "slices/interpreter/interpreterIframeSlice";
import Api from "services/api";
import ConfirmationModal from "components/common/ConfirmationMessage";
import ConfirmationInvitesModal from "components/common/ConfirmationInvites";
import { answerAppointmentInvite } from "slices/interpreter/appointmentSlice";
import { getCheckInStatus } from "slices/userSlice";
import { userSelector } from "slices/userSlice";
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import { isVriType } from "constants/appointmentTypes";

const AppointmentView = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);

  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [answerInviteModal, setAnswerInviteModal] = React.useState('');
  const [answerProcessing, setAnswerProcessing] = React.useState(false);
  const callViewApi = async () => {
    const callBack = (success, message, data, status) => {
      setLoading(false);
      if (success) {
        if (data?.invite_details?.status === "rejected") {
          toast.error(t("appointments.alreadyRejected"), {
            className: "errorToast",
          });
          navigate("/interpreter/dashboard");
          return;
        }
        if (data?.invite_details?.status === "cancelled") {
          navigate("/interpreter/dashboard");
          return;
        }
        setItem(data);
      } else {
        toast.error(message || t("appointments.notAuthorized"), {
          className: "errorToast",
        });
        navigate("/interpreter/dashboard");
      }
    };

    dispatch(fetchInterpreterAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        console.log(data);
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchInterpreterAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    fetchLogs();
  }, [id]);

  const handleAnswerInvite = (answer) => {
    setLoading(true);
    setAnswerProcessing(true);
    const submitCallback = (success, message) => {
      setAnswerProcessing(false);
      if (success) {
        toast.success(message, {
          className: "successToast",
        });
        console.log(answer,'answersss');
        if(answer === 'accept'){
          const isAutoAssign = item?.appointment_details?.auto_assign === 1 && item?.invite_details?.interpreter?.auto_assign === 1
          Swal.fire({
              title: isAutoAssign ? t("appointments.assignedTitle") : t("appointments.thanksForResponding"),
              text: isAutoAssign
                  ? t("appointments.autoAssignSuccessText")
                  : t("appointments.manualAssignNoticeText"),
              icon: "success",
          });
        }
        if (answer === 'decline') {
          navigate(`/interpreter/dashboard`);
          setLoading(false);
          return;
        }
        setAnswerInviteModal('');
        callViewApi();
        fetchLogs();
        setLoading(false);
      } else {
        toast.error(message, { className: "errorToast" });
        setLoading(false);
      }
    };
    dispatch(answerAppointmentInvite(item?.id, { answer: answer }, submitCallback))
  };

  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };

  const handleCancel = () => {
    setCancelModal(true);
  };

  const handleCloseCancel = () => {
    setCancelModal(false);
  };

  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };

  const handleAccept = () => {
    const data = { status: "accepted" };
    handleSubmit(data, "accept", callViewApi);
  };
  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseCheckinCheckoutModal();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        setLoading(false);
        // scheduleDetailModal?.show && openModal()
      } else {
        toast.error(message, {
          className: "errorToast",
        });
        setLoading(false);
      }
    };
    dispatch(setActionAssign(id, data, end_point, submitCallback));
  };

  const InterpreterTimezone = item?.interpreter?.timezone || user?.timezone;
  const AppointmentTimezone = item?.appointment_details?.timezone;
  const rawDatetime = item?.datetime;

  // Date: use appointment timezone so late-night appointments don't shift the date
  const formattedDate = AppointmentTimezone?.name
    ? moment.tz(rawDatetime, AppointmentTimezone.name).format("MMM D, YYYY")
    : moment(rawDatetime).format("MMM D, YYYY");

  // Time in interpreter's timezone: convert from appointment tz → interpreter tz
  const formattedClientTime = (() => {
    if (!rawDatetime) return t("common.nA");
    let m;
    if (AppointmentTimezone?.name && InterpreterTimezone?.name) {
      m = moment.tz(rawDatetime, AppointmentTimezone.name).tz(InterpreterTimezone.name);
    } else if (InterpreterTimezone?.name) {
      m = moment.utc(rawDatetime).tz(InterpreterTimezone.name);
    } else {
      return moment(rawDatetime).format("hh:mm A");
    }
    // const abbr = InterpreterTimezone?.abbreviation;
    // const offset = InterpreterTimezone?.utc_offset;
    // const zone = abbr ? `(${abbr} / GMT${offset})` : `(GMT${offset})`;
    const dynamicAbbr = m.format("z");
    const dynamicOffset = m.format("Z");
    
    const zone = dynamicAbbr ? `(${dynamicAbbr} / GMT${dynamicOffset})` : `(GMT${dynamicOffset})`;
    return `${m.format("hh:mm A")} ${zone}`;
  })();

  const [timeTick, setTimeTick] = React.useState(0);
    React.useEffect(() => {
      const timer = setInterval(() => {
        setTimeTick((prev) => prev + 1);
      }, 60000);
      return () => clearInterval(timer);
    }, []);
  
    const showDurationAlert = React.useMemo(() => {
      if (!item || !item?.id || !rawDatetime) return false;
  
      // 1. Status check: appointment must NOT be completed or cancelled
      const status = (item?.status || "").toLowerCase().trim();
      if (
        status === "completed" ||
        status === "cancelled" ||
        status === "cancelled_by_client" ||
        status === "cancel"
      ) {
        return false;
      }
  
      // 2. Determine target timezone
      const tzName =
        AppointmentTimezone?.name ||
        item?.appointment_details?.timezone?.name ||
        item?.accounts?.timezone?.name ||
        "America/Denver";
  
      // 3. Start moment in appointment timezone
      let cleanDt =
        typeof rawDatetime === "string"
          ? rawDatetime
              .replace("T", " ")
              .replace(/\..+/, "")
              .replace("Z", "")
              .trim()
          : rawDatetime;
      let startM = moment.tz(
        cleanDt,
        [
          "YYYY-MM-DD HH:mm:ss",
          "YYYY-MM-DD HH:mm",
          "YYYY-MM-DDTHH:mm:ss",
          "YYYY-MM-DDTHH:mm:ssZ",
        ],
        tzName
      );
      if (!startM.isValid()) {
        startM = moment.tz(rawDatetime, tzName);
      }
      if (!startM.isValid()) return false;
  
      // 4. Calculate end time
      let endM = null;
      if (item?.estimated_duration) {
        const durationVal = parseFloat(item.estimated_duration);
        if (!isNaN(durationVal) && durationVal > 0) {
          const unit =
            item?.estimated_duration_unit === "hour" ||
            item?.estimated_duration_unit === "hours"
              ? "hours"
              : "minutes";
          const minutes =
            unit === "hours"
              ? Math.round(durationVal * 60)
              : Math.round(durationVal);
          endM = startM.clone().add(minutes, "minutes");
        }
      }
      if (!endM && item?.end_time) {
        const dateStr = item?.date || startM.format("YYYY-MM-DD");
        let parsedEnd = moment.tz(
          `${dateStr} ${item.end_time}`,
          ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm", "YYYY-MM-DD hh:mm A"],
          tzName
        );
        if (parsedEnd.isValid()) {
          if (parsedEnd.isBefore(startM)) {
            parsedEnd.add(1, "day"); // appointment crossed midnight
          }
          endM = parsedEnd;
        }
      }
      if (!endM) {
        // Default fallback: 1 hour duration
        endM = startM.clone().add(1, "hour");
      }
  
      // 5. Compare current time in appointment timezone with appointment end time
      const currentInTz = moment.tz(tzName);
      return currentInTz.isAfter(endM);
    }, [item, rawDatetime, AppointmentTimezone, timeTick]);

  const [recordingUrl, setRecordingUrl] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);


  const [checkinStatus, setCheckinStatus] = useState(0);
  const [checkInternalInterpreterStatus, setCheckcheckInternalInterpreterStatus] = useState(0);

  useEffect(() => {
    dispatch(
      getCheckInStatus((success, data) => {
        if (success) {
          setCheckinStatus(data?.data?.user?.checked_in);
          setCheckcheckInternalInterpreterStatus(data?.data?.user?.internal_interpreter);
        } else {
          console.log("Failed to fetch check-in status", data);
        }
      })
    );
  }, [dispatch]);

  //   Join Video Call handler for interpreter
  const handleInterpreterJoinVideoCall = async () => {
    if (checkinStatus !== 1 && checkInternalInterpreterStatus === 1) {
      toast.error(t("appointments.checkinFirstBeforeVideo"), {
        className: "errorToast",
      });
      return;
    }

    if (
      item?.appointment_details?.video_platform === "external"
    ) {
      try {
        const response = await Api.interpreterJoinExternalVideoCall(id);

        if (response?.status >= 200 && response?.status < 300) {
        const link = item.appointment_details.video_link;

        const url = link.startsWith('http://') || link.startsWith('https://')
          ? link
          : `https://${link}`;

        window.open(url, "_blank");
        } else {
          const errorMsg = response?.data?.error || response?.data?.message || t("appointments.failedToJoinExternalCall");
          toast.error(errorMsg, { className: "errorToast" });
        }
      } catch (err) {
        const serverError = err?.response?.data?.error || err?.message || t("appointments.errorJoiningVideoCall");
        toast.error(serverError, { className: "errorToast" });
        console.error("Error joining external video call:", err);
      }
      return;
    }

    try {
      const response = await Api.interpreterjoinVideoCall(id);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setInterpreterIframeUrl(iframeUrl));
        navigate(`join-room-call`);
        // console.log("Joined successfully:", response);
      } else {
        const errorMsg =
          response?.data?.statusText ||
          response?.data?.message ||
          response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
    }
  };

  //   Show recording popup
  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item?.appointment_details?.recording);
      setShowModal(true);
    } else {
      toast.error(t("appointmentView.recordingUnavailable"), {
        className: "errorToast",
      });
    }
  };

  const inviteStatus = item?.invite_details?.status;

  return (
    <div className="content" style={{}}>
      {loading && <FullPageLoader />}

      <div className="row_main_head bg-primary-secondaryCard bg-primary-secondaryCard-2">
        <h2 className={`main_heading main_heading1`}>
          {t("appointmentView.heading")} {item?.appid}
        </h2>
        <div>
          <div className="text-transform-capitalize main_heading main_heading1">
        {item?.status !== "available" && (
          <span> {t("appointmentView.client")} : {item?.accounts?.user?.name}</span>
        )}
          </div>
        </div>
      </div>
      <>
      {showDurationAlert && (
          <div
            className="row_main_head align-items-center mb-3"
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "8px",
              padding: "6px 12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
              gap: "15px",
            }}
          >
            <div className="d-flex justify-content-start" style={{ gap: "5px" }}>
              <i
                className="fa-solid fa-triangle-exclamation"
                style={{ fontSize: "14px", color: "#856404", flexShrink: 0 }}
              ></i>
              <span style={{ fontSize: "13px", color: "#856404", fontWeight: 500, lineHeight: 1.5 }}>
                We need some information about the duration of your assignment. Please add the details by clicking on the{" "}
                <strong
                  // role="button"
                  // tabIndex={0}
                  style={{
                    textDecoration: "underline",
                    color: "#533f03",
                    fontWeight: 700,
                  }}
                  // onClick={handleOpenCheckinCheckoutModal}
                >
                  Checkin/Checkout
                </strong>{" "}
                option.
              </span>
            </div>
          </div>
        )}
      </>
      {isVriType(item?.type) && item?.status === "assigned" && item?.appointment_details?.video_platform === "external" && !item?.appointment_details?.video_link && (
        <div class="rounded d-flex justify-content-center align-items-center" style={{backgroundColor: '#fcc10052'}}>
            <div className="standby-banner text-dark" style={{fontWeight: 600, padding: '5px 12px', fontSize: '17px' }}>
              {t("appointments.standByForVideoLink")}
            </div>
        </div>
      )}
      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2 view-page`} toLowerCase={"text-lowercase"}>
          {t("table.date")} <span className="dateTime viewpage_tags">{formattedDate}</span>{" "}
          <span className="dateTime viewpage_tags">{formattedClientTime}</span>
        </h2>
        <div className="">
          <div className="text-transform-capitalize main_heading2 d-flex align-items-center">
            <span className="appointmentType viewpage_tags">{item?.type}</span>{" "}
            <span className="appLanguage viewpage_tags">{item?.language?.name}</span>
          </div>
        </div>
      </div>

      <div className="card_table view_table_custom">
        {/* <div className="row_main_head">
                    <h2 className={`main_heading`}>View Appointment </h2>
                    <div className='text-transform-capitalize main_heading' >
                        Status : {item?.status}
                    </div>
                </div>

                <div className="row_table_head">
                    <div className="result-foot">
                        <span>Appointment ID : {item?.appid}</span>
                    </div>
                </div> */}

        <div
          className="row-primary flex-wrap"
          style={{ justifyContent: "space-between" }}
        >
          <div className="row-primary flex-wrap">
            {item?.status == "available" && inviteStatus !== "accepted" && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText={t("appointments.imAvailable")}
                handleSubmit={() => setAnswerInviteModal('accept')}
              />
            )}
            {item?.status == "available" && inviteStatus !== "accepted" && (
              <SubmitButton
                buttonType="button"
                className={"table_delete"}
                btnText={t("appointments.decline")}
                handleSubmit={() => setAnswerInviteModal('decline')}
              />
            )}
            {item?.status == "available" && inviteStatus === "accepted" && (
              <div style={{ color: 'green', fontWeight: '500' }}>
                {t("appointments.inviteAcceptedSuccess")}
              </div>
            )}

            {item?.status !== "cancelled" && item?.status !== "completed" && item?.status !== "available" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText={t("common.cancel")}
                handleSubmit={handleCancel}
              />
            )}
            {item?.status !== "cancelled" && item?.status !== "completed" && item?.status !== "available" && !(isVriType(item?.type) && item?.appointment_details?.video_platform === "external" && !item?.appointment_details?.video_link) && (
              <SubmitButton
                buttonType="button"
                className="Cancle_button"
                btnText={t("appointments.checkinCheckout")}
                // data-bs-toggle="modal"
                // data-bs-target="#checkinCheckoutAdjustmentModal"
                handleSubmit={handleOpenCheckinCheckoutModal}
              />
            )}
          </div>

          {/* Join Video Call & View Recording Buttons  */}
          <div className="row-primary flex-wrap">
            {item?.appointment_details?.recording && (
              <SubmitButton
                className="Cancle_button"
                btnText={t("appointments.viewRecording")}
                handleSubmit={showRecordingPopup}
              />
            )}

            {isVriType(item.type) && item?.status == "assigned" && item?.status !== "completed" && (item?.appointment_details?.video_platform === "algovi" || (item?.appointment_details?.video_platform === "external" && !!item?.appointment_details?.video_link)) && (
              <SubmitButton
                className="green"
                btnText={t("appointments.joinVideoCall")}
                icon={<Video />}
                handleSubmit={handleInterpreterJoinVideoCall}
              />
            )}
          </div>
        </div>

        <ViewTable item={item} />
      </div>

      {/* <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Appointment Logs</h2>
        </div>
        <LogsTable logs={logs} />
      </div> */}

      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
        targetTimezone={InterpreterTimezone?.name}
      />
      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
        end_point="interpreter-cancel"
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
      <ConfirmationInvitesModal
        isOpen={answerInviteModal}
        onClose={() => setAnswerInviteModal('')}
        onConfirm={(ans) => handleAnswerInvite(ans)}
        processing={answerProcessing}
      />
    </div>
  );
};

export default AppointmentView;
